// TODO
// Deprecated, please use HtmlSanitizeService instead

import map from 'lodash/map';
import flatten from 'lodash/flatten';

/**
 * @ngdoc function
 * @name generateRegexp
 * @description generate Regexp
 */
function generateRegexp(tagSet) {
  let regexp = map(tagSet, function (tag) {
    return ['<', tag, '>.+?</', tag, '>'].join('');
  });

  regexp.push('.');

  return new RegExp(regexp.join('|'), 'g');
}

const HTML_EXCEPTIONS = ['sub', 'sup', 'i', 'hi'];
const _mainRegexp = generateRegexp(HTML_EXCEPTIONS);

/**
 * @ngdoc service
 * @name HtmlStripsService
 * @returns {object} holds function to handle html strings
 * @description
 * Service for parsing and handle html strings
 */
class HtmlStripsService {
  /**
   * @ngdoc function
   * @name removeHexUnicodeSymbols
   * @description remove hex unicode symbols
   */
  removeHexUnicodeSymbols(str) {
    return str.replace(/&#x.*;/, ' ');
  }

  /**
   * Strips HTML
   * @param title
   * @param {undefined,string} [stripMethod=undefined,escaped,full,reversed] -
   *  undefined - strips only with exceptions, leaves escaped html
   *  escaped - strips only with exceptions, removed escaped html
   *  full - strips everything
   *  stripexceptions - strips only exceptions, leaves everything else as is
   *  escapeall - just escape everything
   * @returns {*}
   */
  getTitleWithoutHtml = (title, stripMethod) => {
    if (!title) {
      return title;
    }
    let resultTitle = title;

    if (stripMethod === 'full') {
      resultTitle = this.removeHexUnicodeSymbols(resultTitle);
    }

    if (stripMethod === 'stripexceptions') {
      HTML_EXCEPTIONS.forEach((exceptionTag) => {
        const reg = new RegExp(`(<\/?${exceptionTag}.*?>)`, 'gm');
        resultTitle = resultTitle.replace(reg, '');
      });
      return resultTitle;
    }

    resultTitle = resultTitle.replace(/>/g, '&gt;').replace(/</g, '&lt;');

    if (!stripMethod || stripMethod === 'escaped') {
      HTML_EXCEPTIONS.forEach((exceptionTag) => {
        resultTitle = resultTitle.split(`&lt;${exceptionTag}&gt;`).join(`<${exceptionTag}>`)
          .split(`&lt;/${exceptionTag}&gt;`).join(`</${exceptionTag}>`);
      });
    }
    if (stripMethod === 'full' || stripMethod === 'escaped') {
      resultTitle = resultTitle.replace(/(&.*?&gt;)/gm, '');
    }

    return resultTitle;
  };

  /**
   * @ngdoc function
   * @name splitHtmlText
   * @description split html text
   */
  splitHtmlText = (htmlText, lastSymbols) => {
    let match,
      result = {
        first: null,
        last: null,
        full: htmlText
      };

    htmlText = htmlText.trim();

    if (!/<\S+.*>/g.test(htmlText)) { // it's no need to be transformed if it don't have any valid tags
      result.first = htmlText.substr(0, htmlText.length - lastSymbols);
      result.last = htmlText.substr(-lastSymbols);
      return result;
    }

    match = htmlText.match(_mainRegexp);
    match = this.shatterMatches(match);

    // get final result
    result.first = match.slice(0, match.length - lastSymbols).join('');
    result.last = match.slice(match.length - lastSymbols, match.length).join('');

    return result;
  };

  /**
   * @ngdoc function
   * @name shatterMatches
   * @description shatter matches
   */
  shatterMatches = (matches = []) => {
    let results = [];

    matches.forEach(match => {
      if (match === '<') {
        results.push('&lt');
        return;
      }

      // parsed[1] - open tag, parsed[3] - close tag, parsed[2] - visible symbols
      let parsed = /(<.+?>)(.{1,})(<\/.+>)/.exec(match);

      if (parsed) {
        results.push(this.wrapEachSymbol(parsed[2], parsed[1], parsed[3]));
      } else {
        results.push(match);
      }
    });

    return flatten(results);
  };

  /**
   * @ngdoc function
   * @name wrapEachSymbol
   * @description wrap each symbol
   */
  wrapEachSymbol(_string, openTag, closeTag) {
    return map(_string.split(''), function (val) {
      return [openTag, val, closeTag].join('');
    });
  }

  unicodeHtmlEntity = (s) => {
    const hex = s.charAt(2) === 'x';
    const base = hex ? 16 : 10;
    const pos = hex ? 3 : 2;
    const numericValue = parseInt(s.slice(pos, -1), base);
    return String.fromCharCode(numericValue);
  };

  unicodeHtmlEntities(string) {
    return string.replace(/&#x.+;/gm, (s) => this.unicodeHtmlEntity(s));
  }
}


export default new HtmlStripsService();
